<template>
  <div v-if="selfVisible" class="wps-dialog-inner" :data-item-name="reportName" :class="{
    frameless, [wrapClassName || '']: true,
    // 'dialog-mobile-inner': isMobile,
    'dialog-popup': popup,
  }">
    <div class="wps-dialog-mask" @click="maskClose && handleClose(false)"></div>
    <div class="wps-dialog-main" :class="[contentClassName, { 'bottom-close': closeAtBottom }]"
      :style="{ width, height, ...wrapStyles }">
      <div class="wps-dialog-close" v-if="closable" @click="handleClose(false)">
        <img src="~@/assets/images/download/close-icon.svg">
      </div>
      <div class="wps-dialog-header" v-if="!frameless && showHeader && title">
        <div class="wps-dialog-title">
          <img class="status-icon" v-if="icon" :src="icon" />
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-html="title"></span>
        </div>
      </div>
      <div class="wps-dialog-body">
        <slot />
      </div>
      <div class="wps-dialog-footer" v-if="!frameless && (showFooter || $slots.footer)">
        <slot name="footer">
          <Button v-if="cancelText" type="default" @click="handleCancel">{{ cancelText }}</Button>
          <Button v-if="okText" type="primary" @click="handleOk">{{ okText }}</Button>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>

// import { defineComponent } from 'vue';
// import type { StandardShorthandProperties } from 'csstype'

import successIcon from '@/assets/images/download/success.svg'
import warnIcon from '@/assets/images/download/warn.svg'
import failIcon from '@/assets/images/download/fail.svg'
// import app from '@/models/app';

const noop = () => { };

// export interface DialogProps {
//   visible?: boolean
//   title?: string
//   status?: 'success' | 'warn' | 'fail'
//   width?: string
//   height?: string
//   popup?: boolean
//   closeAtBottom?: boolean
//   maskClose?: boolean
//   closable?: boolean
//   frameless?: boolean
//   showHeader?: boolean
//   showFooter?: boolean
//   cancelText?: string
//   okText?: string
//   wrapClassName?: string
//   reportName?: string
//   contentClassName?: string
//   onClose?: (isOK: boolean) => any
//   onOk?: Function
//   onCancel?: Function
//   wrapStyles?: StandardShorthandProperties
// }

export default {
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: [String, Object],
      default: "",
    },
    template: {
      type: String,
      default: "",
    },
    status: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    popup: {
      type: Boolean,
      default: false
    },
    // 关闭按钮是否在弹框下方
    closeAtBottom: {
      type: Boolean,
      default: false
    },
    maskClose: {
      type: Boolean,
      default: true
    },
    onOk: {
      type: Function,
      default: noop,
    },
    onCancel: {
      type: Function,
      default: noop,
    },
    onClose: {
      type: Function,
      default: noop,
    },
    okText: {
      type: String,
      default: "确定",
    },
    cancelText: {
      type: String,
      default: "取消",
    },
    wrapClassName: {
      type: String,
      default: "",
    },
    reportName: {
      type: String,
      default: "",
    },
    contentClassName: {
      type: String,
      default: "",
    },
    wrapStyles: {
      type: Object,
      default: () => { },
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    closable: {
      type: Boolean,
      default: true,
    },
    frameless: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selfVisible: false,
    };
  },
  computed: {
    icon() {
      switch (this.status) {
        case 'success': return successIcon
        case 'warn': return warnIcon
        case 'fail': return failIcon
        default: return this.status || ''
      }
    },
    // isMobile: () => app.getIsMobile(),
  },
  model: {
    event: "close",
    prop: "visible",
  },
  beforeMount() {
    this.selfVisible = !!this.visible
  },
  methods: {
    handleClose(isOK) {
      this.onClose && this.onClose(isOK);
      this.selfVisible = false;
      this.$emit("close", false);
    },
    async handleCancel() {
      await (this.onCancel && this.onCancel());
      this.handleClose(false)
    },
    async handleOk() {
      await (this.onOk && this.onOk());
      this.handleClose(true)
    },
  },
}

</script>
<style lang="scss" scoped>
.wps-dialog {

  &-pcoffice {
    .wps-dialog-mask {
      background-color: transparent;
    }

    .wps-dialog-main {
      box-shadow: 0 6px 20px 0 rgba(0, 0, 0, .3);
    }
  }

  &-wrapper {
    display: block;
    color: #3C414B;
    font-size: 14px;

    &.hide-close {
      .wps-dialog-close {
        display: none;
      }
    }
  }

  &-inner {
    z-index: 9999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    // &.animate {
    //   .wps-dialog-mask {
    //     background-color: rgba(0,0,0,0);
    //   }
    //   .wps-dialog-main {
    //     height: 0;
    //   }
    // }
    &.frameless {
      .wps-dialog-body {
        padding: 0;
      }
    }
  }

  &-mask {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    transition: background-color 200ms ease;
  }

  &-main {
    padding: 32px 40px 40px 40px;
    // padding: 14px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 600px;
    max-width: 95vw;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.05), 0 3px 9px 0 rgba(0, 0, 0, 0.10);
    box-sizing: border-box;
    transition: height 100ms ease;
  }

  &-header {
    padding: 24px 0;
    margin: 0 30px;
    line-height: 30px;
    font-size: 20px;
    position: relative;
    box-sizing: border-box;
    border-bottom: 1px solid #E7E9EB;
  }

  &-title {
    .status-icon {
      vertical-align: middle;
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
  }

  &-close {
    // background: url(../img/close.png) no-repeat center center;
    background-size: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    position: absolute;
    right: 30px;
    top: 30px;
    cursor: pointer;
    z-index: 1;
    text-align: center;
    transition: all 100ms ease-in;
    border-radius: 4px 0 4px 4px;

    &:hover {
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.04) !important;
    }

    &:active {
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.06) !important;
    }

    img {
      width: 24px;
      height: 24px;
      vertical-align: middle;
      transition: all 100ms ease-in;
    }
  }

  &-body {
    padding: 0px 30px;
    min-height: 22px;
  }

  &-footer {
    text-align: right;
    padding: 30px;
  }

}
</style>